import type {
    MarkAsPaidBySellerApiRequest,
    PickListBuyerV2ApiDto,
    SetItemShippedApiRequest,
    SetTransactionVisibilityApiRequest
} from 'tradera/state/services/types/webapi-member-generated';

type FieldUpdate =
    | {
          isMarkedAsShipped: boolean;
      }
    | {
          isMarkedAsPaidBySeller: boolean;
      }
    | {
          hiddenBySeller: boolean;
      };

const setBuyerItemProperty = (
    items: PickListBuyerV2ApiDto[],
    purchaseOrderId: string,
    update: FieldUpdate
) => {
    return items.map((buyer) => ({
        ...buyer,
        items: buyer.items?.map((item) => {
            return purchaseOrderId === item.purchaseOrderId
                ? {
                      ...item,
                      ...update
                  }
                : item;
        })
    }));
};

export const updateShippingStatusForBuyerItems = (
    patch: SetItemShippedApiRequest,
    buyers?: PickListBuyerV2ApiDto[] | null
) => {
    return setBuyerItemProperty(buyers ?? [], patch.purchaseOrderId, {
        isMarkedAsShipped: patch.shipped
    });
};

export const updatePaidStatusForBuyerItems = (
    patch: MarkAsPaidBySellerApiRequest,
    buyers?: PickListBuyerV2ApiDto[] | null
) => {
    return setBuyerItemProperty(buyers ?? [], patch.purchaseOrderId, {
        isMarkedAsPaidBySeller: patch.paidConfirmed
    });
};

export const updateVisibilityStatusForBuyerItems = (
    patch: SetTransactionVisibilityApiRequest,
    buyers?: PickListBuyerV2ApiDto[] | null
) => {
    return setBuyerItemProperty(buyers ?? [], patch.purchaseOrderId, {
        hiddenBySeller: patch.hidden
    })
        .map((buyer) => ({
            ...buyer,
            items: buyer.items?.filter(
                (item) => item.hiddenBySeller !== patch.hidden
            )
        }))
        .filter((buyer) => buyer.items?.length ?? 0 > 0);
};
